<script>
import Modal from "@/pages/components/modal.vue";
import moment from "@wielink-application/shared/js/mixins/moment";
import {Link, router} from '@inertiajs/vue3';

export default {
  mixins: [moment],
  components: {Modal, Link},
  props: {
    appointment: {
      type: Object,
      default: {}
    }
  },
  methods: {
    open() {
      this.$refs.modal.open();
    },

    close() {
      this.$refs.modal.close();
    },

    async goto(event) {
      let url = $(event.currentTarget).attr('href');

      await new Promise((resolve) => {
        this.close();
        $(this.$refs.modal.$el).on('hidden.bs.modal', event => resolve(true));
      });

      router.get(url);
    }
  },
  computed: {
    products() {
      if (!this.appointment.products) {
        return '';
      }
      return this.appointment.products.map(product => product.product.type_tester.code ?? product.product.serial_number).join(', ');
    },

    maps_url() {
      if (!this.appointment.customer) {
        return '';
      }
      return `https://www.google.nl/maps/dir//${this.appointment.customer.full_address}/`;
    }
  },
}
</script>

<template>
  <Modal id="show-appointment-modal" title="Afspraak" ref="modal">
    <table class="w-100 m-0">
      <tbody>
        <tr class="border-bottom" valign="top">
          <td class="py-1 fw-bold pe-3">Afspraak</td>
          <td class="py-1">{{ appointment.name }}</td>
        </tr>
        <tr class="border-bottom" valign="top">
          <td class="py-1 fw-bold pe-3">Route</td>
          <td class="py-1">
            <a target="_blank" :href="maps_url">Openen in google maps</a>
          </td>
        </tr>
        <tr class="border-bottom" valign="top">
          <td class="py-1 fw-bold pe-3">Tijd</td>
          <td class="py-1">{{ moment(appointment.start_date).format('HH:mm') }} - {{ moment(appointment.end_date).format('HH:mm') }}</td>
        </tr>
        <tr class="border-bottom" valign="top">
          <td class="py-1 fw-bold pe-3">Producten</td>
          <td class="py-1">{{ products }}</td>
        </tr>
        <tr class="border-bottom" valign="top">
          <td class="py-1 fw-bold pe-3">Extra</td>
          <td class="py-1">{{ appointment.description }}</td>
        </tr>
        <tr class="border-bottom" valign="middle">
          <td class="py-1 fw-bold pe-3">Vaste telefoon</td>
          <td class="py-1">
            <template v-if="appointment.customer && appointment.customer.phone">
              <div class="d-flex align-items-center">
                <a :href="'tel:' + appointment.customer.phone_number_formatted">{{ appointment.customer.phone }}</a>
                <a class="lh-1 ps-2 ms-auto" style="font-size: 2em; color: #0bc042;" target="_blank" :href="'https://wa.me/' + appointment.customer.phone_number_formatted" aria-label="Naar whatsapp" title="Naar whatsapp">
                  <i class="bi bi-whatsapp lh-1"></i>
                </a>
              </div>
            </template>
            <template v-if="!appointment.customer || !appointment.customer.phone">-</template>
          </td>
        </tr>
        <tr class="border-bottom" valign="middle">
          <td class="py-1 fw-bold pe-3">Mobiel</td>
          <td class="py-1">
            <template v-if="appointment.customer && appointment.customer.mobile">
              <div class="d-flex align-items-center">
                <a :href="'tel:' + appointment.customer.mobile_number_formatted">{{ appointment.customer.mobile }}</a>
                <a class="lh-1 ps-2 ms-auto" style="font-size: 2em; color: #0bc042;" target="_blank" :href="'https://wa.me/' + appointment.customer.mobile_number_formatted" aria-label="Naar whatsapp" title="Naar whatsapp">
                  <i class="bi bi-whatsapp lh-1"></i>
                </a>
              </div>
            </template>
            <template v-if="!appointment.customer || !appointment.customer.mobile">-</template>
          </td>
        </tr>
        <tr class="border-bottom" valign="top">
          <td class="py-1 fw-bold pe-3">Keuringsrapporten</td>
          <td class="py-1">
            <a v-if="appointment.id" @click.prevent="goto" :href="route('inspection_reports.index', {appointment: appointment.id})">Naar keuring</a>
          </td>
        </tr>
      </tbody>
    </table>
  </Modal>
</template>